var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.content)?_c('section',{staticClass:"container margin-both-xl"},[_c('HtmlContent',{staticClass:"no-padding",attrs:{"html":_vm.updatedContent(_vm.data.content)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }